import Loader from "components/Loader/Loader";
import { useAppDispatch } from "hooks/hooks";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  getCarnetsMealsStatistics,
  selectState,
} from "../slices/CarnetsMealsStatistics.slice";
import { FormatNumber} from "../services/statistics.service";
import { selectState as mainSelectState } from "../slices/main.slice";
import { mapMonths } from "utils/dateUtils";

export const CarnetsStatistics = () => {
  const { statistics, loading } = useSelector(selectState);
  const { mainDateFrom } = useSelector(mainSelectState);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (mainDateFrom != null){
      dispatch(getCarnetsMealsStatistics({ year: mainDateFrom?.getFullYear() }));
    }
  }, [dispatch, mainDateFrom]);

  const getHighestCarnet = () => {
    let highest = 0;
    statistics?.monthlyCosts.forEach((element) => {
      if (element.carnetsCostForFixedSalaries > highest) {
        highest = element.carnetsCostForFixedSalaries;
      }
      if (element.carnetsTotalCost > highest) {
        highest = element.carnetsTotalCost;
      }
    });
    return highest;
  };

  const getHighestMeal = () => {
    let highest = 0;
    statistics?.monthlyCosts.forEach((element) => {
      if (element.mealsForCashCost > highest) {
        highest = element.mealsForCashCost;
      }
      if (element.mealsTotalCost > highest) {
        highest = element.mealsTotalCost;
      }
    });
    return highest;
  };

  const getHeightCarnet = (num: number | undefined) => {
    if (num === 0) {
      return 0;
    }
    if (num) {
      const result = 100 / (getHighestCarnet() / num);
      if (Math.round(result) === 0 && num > 0) {
        return 1;
      }
      return Math.round(result);
    }
  };

  const getHeightMeal = (num: number | undefined) => {
    if (num === 0) {
      return 0;
    }
    if (num) {
      const result = 100 / (getHighestMeal() / num);
      if (Math.round(result) === 0 && num > 0) {
        return 1;
      }
      return Math.round(result);
    }
  };

  return (
    <div className="extendedDiv loading-container">
      {loading && <Loader />}
      <div className="header">Karneti mesečno</div>
      <div className="graphs carnets">
        <div className="graphs-header carnets-header">
          <span>
            <div className="color7"></div>Karneti
          </span>
          <span>
            <div className="color6"></div>Karneti zaposlenih sa fiksnim platama
          </span>
        </div>
        <div className="graphs-content ">
          {statistics?.monthlyCosts &&
            statistics.monthlyCosts.map((s, index) => (
              <div key={index} className="monthDiv">
                <p>{mapMonths(s.month)}</p>
                <div className="dualGraphs">
                  <span
                    className={`carnetGraph-${getHeightCarnet(
                      s.carnetsTotalCost
                    )}`}
                  >
                    <p>{FormatNumber(s.carnetsTotalCost)}</p>
                    <div className="color7"></div>
                  </span>
                  <span
                    className={`carnetGraph-${getHeightCarnet(
                      s.carnetsCostForFixedSalaries
                    )}`}
                  >
                    <p>{FormatNumber(s.carnetsCostForFixedSalaries)}</p>
                    <div className="color6"></div>
                  </span> 
                </div>
              </div>
            ))}
        </div>
      </div>
      <div className="header">Obroci mesečno</div>
      <div className="graphs carnets">
        <div className="graphs-header carnets-header">
          <span>
            <div className="color7"></div>Obroci ukupno
          </span>
          <span>
            <div className="color6"></div>Keš obroci
          </span>
        </div>
        <div className="graphs-content loading-container">
          {statistics?.monthlyCosts &&
            statistics.monthlyCosts.map((s, index) => (
              <div key={index} className="monthDiv">
                <p>{mapMonths(s.month)}</p>
                <div className="dualGraphs">
                  <span
                    className={`carnetGraph-${getHeightMeal(s.mealsTotalCost)}`}
                  >
                    <p>{FormatNumber(s.mealsTotalCost)}</p>
                    <div className="color7"></div>
                  </span>
                  <span
                    className={`carnetGraph-${getHeightMeal(
                      s.mealsForCashCost
                    )}`}
                  >
                    <p>{FormatNumber(s.mealsForCashCost)}</p>
                    <div className="color6"></div>
                  </span>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};
